import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail, PARTNER_TOKEN_KEY } from "../lib/api";

const PartnerContext = createContext(null);

export const PartnerProvider = ({ children }) => {
  const [partner, setPartner] = useState(null); // null=checking, false=unauth, object=auth
  const [error, setError] = useState("");

  const loadMe = useCallback(async () => {
    if (!localStorage.getItem(PARTNER_TOKEN_KEY)) {
      setPartner(false);
      return;
    }
    try {
      const { data } = await http.get("/partners/me");
      setPartner(data);
    } catch {
      localStorage.removeItem(PARTNER_TOKEN_KEY);
      setPartner(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await http.post("/partners/login", { email, password });
      if (data.token) localStorage.setItem(PARTNER_TOKEN_KEY, data.token);
      setPartner(data.partner);
      return { ok: true, partner: data.partner };
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const register = async (payload) => {
    setError("");
    try {
      const { data } = await http.post("/partners/register", payload);
      return { ok: true, data };
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const logout = async () => {
    try { await http.post("/partners/logout"); } catch {}
    localStorage.removeItem(PARTNER_TOKEN_KEY);
    setPartner(false);
  };

  return (
    <PartnerContext.Provider value={{ partner, error, login, register, logout, setPartner, refresh: loadMe }}>
      {children}
    </PartnerContext.Provider>
  );
};

export const usePartner = () => useContext(PartnerContext);
